import { DateTime } from 'luxon';
import { InjectionKey, Ref } from 'vue';
import { DeleteAllocationType, UpdateAllocationType } from './allocation/types';

// This follows the recommendation for typing Provide/Inject: https://vuejs.org/guide/typescript/composition-api.html#typing-provide-inject

export const emitDeleteAllocationKey = Symbol('emitDeleteAllocationKey') as InjectionKey<DeleteAllocationType>;

export const emitUpdateAllocationKey = Symbol('emitUpdateAllocationKey') as InjectionKey<UpdateAllocationType>;

export const hoveredTimelinePartsKey = Symbol('hoveredTimelinePartsKey') as InjectionKey<{
    rowId: Ref<string | null>;
    columnId: Ref<string | null>;
    isConflictCell: Ref<boolean>;
}>;
export const hoverTimelinePartKey = Symbol('hoverTimelinePartKey') as InjectionKey<
    (rowId: string | null, columnId: string | null, isConflictCell: boolean) => void
>;
export const positionInLayoutRowKey = Symbol('positionInLayoutRowKey') as InjectionKey<
    ((allocationId: string) => { left: number | null; top: number | null }) | undefined
>;

export const registerAllocationKey = Symbol('registerAllocationKey') as InjectionKey<
    (allocationId: string, triggerHighlight: () => void) => void
>;
export const unregisterAllocationKey = Symbol('unregisterAllocationKey') as InjectionKey<
    (allocationId: string) => void
>;
export const timelineRangeKey = Symbol('timelineRangeKey') as InjectionKey<{
    startDateTime: Ref<DateTime>;
    endDateTime: Ref<DateTime>;
}>;
